import './sentry';
import '@shared/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import { PlatformServicesProvider } from '@/platform/context';
import { createWebPlatformServices } from '@/platform/web';
import '@/styles/globals.css';
import '@/styles/fonts';

const platformServices = createWebPlatformServices();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlatformServicesProvider services={platformServices}>
      <App />
    </PlatformServicesProvider>
  </React.StrictMode>
);

